import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ContactUnlock } from "@/components/ContactUnlock";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Loader2, Send } from "lucide-react";

export default function ProfileView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [c, setC] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/contacts/${id}`).then(({ data }) => {
      if (data.is_usta) { navigate(`/usta/${id}`, { replace: true }); return; }
      setC(data);
    }).catch(() => setNotFound(true));
  }, [id, navigate]);

  if (notFound) return (
    <div className="max-w-2xl mx-auto px-4 py-20 text-center" data-testid="profile-not-found">
      <p className="text-lg font-bold text-slate-700">Hesap Kapatıldı</p>
      <p className="text-sm text-slate-500 mt-2">Bu kullanıcı hesabını kapatmış veya profil bulunamıyor.</p>
    </div>
  );
  if (!c) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-emerald-500" /></div>;
  const isSelf = user?.id === id;

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white rounded-2xl border border-slate-200/80 overflow-hidden">
        <div className="h-28 brand-gradient" />
        <div className="px-6 pb-6">
          <div className="-mt-12 flex items-end gap-4">
            <Avatar className="h-24 w-24 border-4 border-white">
              <AvatarImage src={c.avatar} /><AvatarFallback className="bg-emerald-100 text-emerald-700 text-2xl">{c.name?.[0]}</AvatarFallback>
            </Avatar>
            <div className="pb-1">
              <h1 className="text-2xl font-extrabold text-slate-900" data-testid="profile-name">{c.name}</h1>
              <span className="inline-block mt-1 text-xs font-bold text-slate-600 bg-slate-100 px-3 py-1 rounded-full" data-testid="not-usta-badge">Usta Değil</span>
            </div>
          </div>

          {!isSelf && (
            <div className="mt-5 flex items-center gap-2" data-testid="profile-contact">
              <span className="text-sm font-semibold text-slate-500">Telefon:</span>
              <ContactUnlock targetUserId={id} compact />
            </div>
          )}

          {!isSelf && (
            <Button onClick={() => navigate(`/mesajlar?to=${id}`)} variant="outline" className="mt-4 rounded-xl border-emerald-200 text-emerald-700" data-testid="profile-message-button">
              <Send className="h-4 w-4 mr-1.5" /> Mesaj Gönder
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
